var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ModularProfessionPage flex flex-col gap-4"},_vm._l((_vm.resolvedModules),function(mod){return _c(mod.component,{key:`${mod.slug}-${mod.position}`,tag:"component",attrs:{"module-config":mod.moduleConfig,"is-after-hero":mod.isAfterHero,"merged-heading-content":mod.mergedHeadingContent}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }